import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=071cc0e4&scoped=true"
import script from "./DiscountForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiscountForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DiscountForm.vue?vue&type=style&index=0&id=071cc0e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071cc0e4",
  null
  
)

export default component.exports